import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Formata um número como moeda brasileira
export function formatCurrency(value: string | number): string {
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(numericValue);
}

// Converte uma string decimal do Supabase para número
export function fromDecimal(value: string | null | undefined): number {
  if (!value) return 0;
  return parseFloat(value);
}

// Converte um número para string decimal do Supabase
export function toDecimal(value: number): string {
  return value.toFixed(2);
}

// Formata uma data para exibição
export function formatDate(date: string | Date, options: Intl.DateTimeFormatOptions = {}): string {
  const defaultOptions: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    ...options
  };

  return new Intl.DateTimeFormat('pt-BR', defaultOptions).format(
    typeof date === 'string' ? new Date(date) : date
  );
}

// Formata um valor monetário para entrada de usuário (sem símbolo da moeda)
export function formatMoneyInput(value: string | number): string {
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(numericValue);
}

// Converte um valor monetário formatado de volta para número
export function parseMoneyInput(value: string): number {
  // Remove tudo que não for número ou vírgula
  const cleanValue = value.replace(/[^\d,]/g, '');
  // Substitui vírgula por ponto para o parseFloat
  const numericString = cleanValue.replace(',', '.');
  return parseFloat(numericString) || 0;
}

// Cria URLs para navegação no app
export function createPageUrl(path: string, params?: Record<string, string | number>): string {
  let url = path;
  if (params) {
    const queryString = Object.entries(params)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    url += `?${queryString}`;
  }
  return url;
}
